module.exports = __webpack_public_path__ + "static/scale-model-of-tennessee-aquarium-in-chattanooga-tennessee-f6cff19b715e4220e96a8e0148403163.png";